export const m365Statuses = [
  { label: 'Failed', value: 'false', color: '#C91118' },
  { label: 'Successfully', value: 'true', color: '#35C91F' },
];
export default m365Statuses;
